<h2 class="rs-tit3">
  {{ "modem-choice.vlan-title" | translate }}
</h2>
<p>
  {{ "modem-choice.vlan-description" | translate }}
</p>
<div class="row">
  <div class="columns small-12 medium-4">
    <div class="rs-form-item">
      <select
        id="mprd-modem-choice-vlan"
        class="rs-filled"
        [formControl]="vlan"
      >
        <option *ngFor="let mode of MODES" [ngValue]="mode">
          {{ "modem-choice.vlan-" + mode | translate }}
        </option>
      </select>
      <label class="rs-form-label" for="mprd-modem-choice-vlan">
        {{ "modem-choice.vlan-current" | translate }}
      </label>
    </div>
  </div>
</div>
<div class="rs-me"></div>

<mprd-loading-modal
  *ngIf="pending"
  [message]="'modem-choice.vlan-pending' | translate"
></mprd-loading-modal>
